import { useSelector } from 'react-redux';
import { StateAdvertReviewCheck } from '#reviewCheck/types';

const useAdvertReviewCheckState = (): StateAdvertReviewCheck => useSelector(
  (state: { advertReviewCheck: StateAdvertReviewCheck }) => state.advertReviewCheck,
);

export { useAdvertReviewCheckState };
